export enum MainToWorkerMessageType {
  Connect,
  Disconnect,
  Subscribe,
  Unsubscribe,
  Updated,
  UpdateCommunicationCondition,
  SubscribeGroupById,
  UnsubscribeGroup
}

export enum WorkerToMainMessageType {
  Connecting,
  Connected,
  Disconnected,
  Subscribed,
  Unsubscribed,
  UpdateJobActivity,
  UpdateSpreadingJob,
  UpdateHaulageJob,
  UpdateDigestateJob
}
